import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import config from '../../config';
import AnalyticsActionCreator from '../../actions/AnalyticsActionCreator';
import SpendingsActionCreator from '../../actions/SpendingsActionCreator';
import SpendingsUtils from '../../utils/SpendingsUtils';
import NumberUtils from '../../utils/NumberUtils';
import BrowserUtils from '../../utils/BrowserUtils';
import SiteHeaderActionCreator from '../../actions/SiteHeaderActionCreator';

/**
 * @todo
 * The quality of this component is poor.
 * Future improvement work should be done to address this.
 */
class SpendingsEarnings extends Component {
  constructor(props) {
    super(props);

    this._earningsOnBlur = this._earningsOnBlur.bind(this);
    this._earningsOnChange = this._earningsOnChange.bind(this);
    this._handleCancel = this._handleCancel.bind(this);
    this._handleNext = this._handleNext.bind(this);
    this._loadSpendingAction = this._loadSpendingAction.bind(this);
    this._onPaste = this._onPaste.bind(this);

    this.state = {
      nextButtonDisabled: false,
      earnings: props.earnings,
    };
  }

  componentWillMount() {
    BrowserUtils.isMobileView() && SiteHeaderActionCreator.hideHeaderFlag(true);
    if (
      this.state.earnings.period.net_income.value === '' ||
      !this.state.earnings.period.net_income.value
    ) {
      const earning = _.extend({}, this.state.earnings);
      earning.period.net_income.value = '£';
      this.setState({
        nextButtonDisabled: true,
        clasname: 'btn btn-link btn-style hide',
        earnings: earning,
      });
    } else {
      this.setState({
        nextButtonDisabled: false,
        clasname: 'btn btn-link btn-style',
      });
    }
  }

  componentDidMount() {
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/view',
        action: 'Appeared',
      },
      {
        description: config.analytics.analytics_name_budget_income,
      }
    );
  }

  componentWillUnmount() {
    SiteHeaderActionCreator.hideHeaderFlag(false);
  }

  _earningsOnBlur() {
    const earning = _.extend({}, this.state.earnings);
    if (_.isNumber(this.state.earnings.period.net_income.value)) {
      earning.period.net_income.value = NumberUtils.appendCurrency(
        '{}',
        Number(this.state.earnings.period.net_income.value)
      );
    } else {
      const income = parseFloat(
        this.state.earnings.period.net_income.value.replace(/[^\d.]*/g, '')
      );
      if (_.isNaN(income)) {
        earning.period.net_income.value = '£';
      } else {
        earning.period.net_income.value = NumberUtils.appendCurrency(
          '{}',
          Number(income)
        );
      }
    }
    this.setState({ earnings: earning });
  }

  _earningsOnChange(e) {
    const earning = _.extend({}, this.state.earnings);
    const isValid = SpendingsUtils.numberValidation(e.target.value);
    let etarget;
    if (isValid) {
      etarget = e.target.value.replace(/[^\d.]*/g, '');
      earning.period.net_income.value = `£${etarget}`;
      if (etarget === '') {
        earning.period.net_income.value = `£${etarget}`;
        this.setState({
          nextButtonDisabled: true,
          clasname: 'btn btn-link btn-style hide',
        });
      } else if (etarget === '.' || etarget === '0.') {
        earning.period.net_income.value = `£${etarget}`;
        this.setState({
          nextButtonDisabled: true,
          clasname: 'btn btn-link btn-style hide',
        });
      } else if (etarget === '0') {
        earning.period.net_income.value = `£${etarget}`;
        this.setState({
          nextButtonDisabled: true,
          clasname: 'btn btn-link btn-style hide',
        });
      } else if (etarget === '0.0') {
        earning.period.net_income.value = `£${etarget}`;
        this.setState({
          nextButtonDisabled: true,
          clasname: 'btn btn-link btn-style hide',
        });
      } else if (etarget === '0.00') {
        earning.period.net_income.value = `£${etarget}`;
        this.setState({
          nextButtonDisabled: true,
          clasname: 'btn btn-link btn-style hide',
        });
      } else if (Number(etarget) === 0) {
        earning.period.net_income.value = '£0';
        this.setState({
          nextButtonDisabled: true,
          clasname: 'btn btn-link btn-style hide',
        });
      } else {
        this.setState({
          nextButtonDisabled: false,
          clasname: 'btn btn-link btn-style',
        });
      }
      this.setState({ earnings: earning });
    }
  }

  _handleCancel() {
    this._loadSpendingAction();
    if (BrowserUtils.isMobileView()) {
      SpendingsActionCreator.checkScreenFlag(0);
    }
  }

  _handleNext() {
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description: config.analytics.analytics_name_budget,
        event: 'click',
      }
    );
    const earning = _.extend({}, this.state.earnings);
    if (_.isNumber(this.state.earnings.period.net_income.value)) {
      earning.period.net_income.value =
        this.state.earnings.period.net_income.value;
    } else {
      earning.period.net_income.value = parseFloat(
        this.state.earnings.period.net_income.value.replace(/[^\d.]*/g, '')
      );
    }
    SpendingsActionCreator.requestEditBudgetPage();
  }

  _loadSpendingAction() {
    SpendingsActionCreator.getAccountsList();
    SpendingsActionCreator.getBudgetConnection();
    SpendingsActionCreator.getTagListConnection();
    SpendingsActionCreator.getBudgetPreferencesConnection();
  }

  _onPaste(e) {
    e.preventDefault();
  }

  render() {
    const content = this.props.content;
    // todo global variable manipulation going on here!
    let createEditBudgetTittle; // eslint-disable-line
    let earning = this.state.earnings.period.net_income.value;
    if (_.isNumber(earning)) {
      earning = `£${this.state.earnings.period.net_income.value}`;
    }
    const allBudgetTarget = _.sum(this.props.allBudgetTarget);
    if (allBudgetTarget <= 0) {
      createEditBudgetTittle = <div>{content.spendingHeaderButtonLabel2}</div>;
    } else {
      createEditBudgetTittle = <div>{content.spendingHeaderButtonLabel3}</div>;
    }
    return (
      <div className="spendings-create full-height">
        <div className="row header-row no-gutters">
          <div className="col-xs-6">
            <button
              type="button"
              className="btn btn-link btn-style"
              onClick={this._handleCancel}
            >
              {content.spendingCancelButtonText}
            </button>
          </div>
        </div>
        <div className="row text-center">
          <div className="create-content">
            <div className="content-style">
              <p>{content.spendingEarningMessage1}</p>
            </div>
            <input
              type="text"
              value={earning}
              className="text-style"
              onChange={this._earningsOnChange}
              onBlur={this._earningsOnBlur}
              onPaste={this._onPaste}
            />
          </div>
        </div>
        <div className="row header-row no-gutters">
          <div className="col-xs-12 text-right anticipated-earning-budget">
            <button
              type="button"
              className={this.state.clasname}
              onClick={this._handleNext}
              disabled={this.state.nextButtonDisabled}
            >
              {content.spendingSaveButtonText}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

SpendingsEarnings.propTypes = {
  content: PropTypes.object,
  earnings: PropTypes.object,
  allBudgetTarget: PropTypes.array,
};

export { SpendingsEarnings };
